import { Breakpoints } from 'scripts/presentation/themes/breakpoints';

export const Device = {
  Phone: 'phone',
  Tablet: 'tablet',
  Desktop: 'desktop',
};

// Re-evaluates on every call so resize/orientation re-detection works through
// the DeviceProvider's useWindowSize re-render. The single source of truth is
// the DeviceContext value committed alongside the wrapper div's data-device
// attribute — callers outside the React tree should reach for that context.
export function getDevice() {
  const override = readOverride();
  if (override) return override;

  const coarse = matches('(pointer: coarse)');
  const noHover = matches('(hover: none)');
  // Use the shortest viewport side so landscape phones (e.g. iPhone 14 at
  // 844x390) still classify as Phone instead of slipping into Tablet because
  // their long edge crosses Breakpoints.md.
  const shortestSide = Math.min(window.innerWidth, window.innerHeight);

  if (coarse && noHover && shortestSide < Breakpoints.md) return Device.Phone;
  if (coarse && noHover) return Device.Tablet;
  return Device.Desktop;
}

function readOverride() {
  // Dev/QA only — we don't want a `?device=phone` URL to force the phone shell
  // for real customers in production.
  if (process.env.NODE_ENV === 'production') return null;
  try {
    const url = new URL(window.location.href);
    const value = url.searchParams.get('device');
    if (value === 'phone') return Device.Phone;
    if (value === 'tablet') return Device.Tablet;
    if (value === 'desktop') return Device.Desktop;
  } catch (e) {
    // URL parsing failures fall through to media-query detection.
  }
  return null;
}

function matches(query) {
  return typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}
